import React, { ReactElement, ReactNode } from 'react';
import { Field } from 'react-final-form';
import { SelectFieldOption } from '~common/components/select.component';
import { ThemedSelect } from '~common/components/themed-select.component';

interface Props {
  name: string;
  label: string;
  options: SelectFieldOption[];
  disabled?: boolean;
}

export const SelectField = (props: Props): ReactElement => {
  const { name, label, options, disabled, ...rest } = props;
  return (
    <Field
      label={label}
      name={name}
      render={(renderProps): ReactNode => (
        <ThemedSelect options={options} disabled={disabled} {...renderProps} />
      )}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-select.component.tsx